export default __webpack_public_path__ + "static/media/add-img.0c213e1c.svg";